// extracted by mini-css-extract-plugin
var _1 = "active";
var _2 = "active-media-preview";
var _3 = "base-link";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "header";
var _13 = "header--displayed";
var _14 = "header--hidden";
var _15 = "header-link";
var _16 = "header-link--desktop";
var _17 = "header-link--dropdown";
var _18 = "header-link__triangle";
var _19 = "header-link__triangle--opened";
var _1a = "headerContent";
var _1b = "headerFixed";
var _1c = "headerLinkActive";
var _1d = "headerLinkLGD";
var _1e = "headerProductTypeIcon";
var _1f = "headerProductTypeMenuItem";
var _20 = "headerProductTypeMenuWrapper";
var _21 = "header__cache-proxy";
var _22 = "header__chapters";
var _23 = "header__hm";
var _24 = "header__left";
var _25 = "header__link";
var _26 = "header__link--collections";
var _27 = "header__link--desktop";
var _28 = "header__link--disabled";
var _29 = "header__link--icon";
var _2a = "header__link-title";
var _2b = "header__links";
var _2c = "header__logo";
var _2d = "header__mobile";
var _2e = "header__mobile--opened";
var _2f = "header__mobile-item";
var _30 = "header__mobile-item-list";
var _31 = "hide-header";
var _32 = "hide-on-small-screens";
var _33 = "iconFancy";
var _34 = "label";
var _35 = "pinned-collection";
var _36 = "pinned-collection__label";
var _37 = "pinned-collection__link";
var _38 = "popover-container";
var _39 = "reset-button";
var _3a = "1200px";
var _3b = "992px";
var _3c = "1366px";
var _3d = "768px";
var _3e = "1475px";
var _3f = "576px";
var _40 = "1600px";
var _41 = "320px";
var _42 = "2500px";
var _43 = "show-header";
var _44 = "show-on-small-screens";
var _45 = "single-page-responsive-font-size";
export { _1 as "active", _2 as "active-media-preview", _3 as "base-link", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "header", _13 as "header--displayed", _14 as "header--hidden", _15 as "header-link", _16 as "header-link--desktop", _17 as "header-link--dropdown", _18 as "header-link__triangle", _19 as "header-link__triangle--opened", _1a as "headerContent", _1b as "headerFixed", _1c as "headerLinkActive", _1d as "headerLinkLGD", _1e as "headerProductTypeIcon", _1f as "headerProductTypeMenuItem", _20 as "headerProductTypeMenuWrapper", _21 as "header__cache-proxy", _22 as "header__chapters", _23 as "header__hm", _24 as "header__left", _25 as "header__link", _26 as "header__link--collections", _27 as "header__link--desktop", _28 as "header__link--disabled", _29 as "header__link--icon", _2a as "header__link-title", _2b as "header__links", _2c as "header__logo", _2d as "header__mobile", _2e as "header__mobile--opened", _2f as "header__mobile-item", _30 as "header__mobile-item-list", _31 as "hide-header", _32 as "hide-on-small-screens", _33 as "iconFancy", _34 as "label", _35 as "pinned-collection", _36 as "pinned-collection__label", _37 as "pinned-collection__link", _38 as "popover-container", _39 as "reset-button", _3a as "screenlg", _3b as "screenmd", _3c as "screenml", _3d as "screensm", _3e as "screenxlg", _3f as "screenxs", _40 as "screenxxlg", _41 as "screenxxs", _42 as "screenxxxlg", _43 as "show-header", _44 as "show-on-small-screens", _45 as "single-page-responsive-font-size" }
export default { "active": _1, "active-media-preview": _2, "base-link": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "header": _12, "header--displayed": _13, "header--hidden": _14, "header-link": _15, "header-link--desktop": _16, "header-link--dropdown": _17, "header-link__triangle": _18, "header-link__triangle--opened": _19, "headerContent": _1a, "headerFixed": _1b, "headerLinkActive": _1c, "headerLinkLGD": _1d, "headerProductTypeIcon": _1e, "headerProductTypeMenuItem": _1f, "headerProductTypeMenuWrapper": _20, "header__cache-proxy": _21, "header__chapters": _22, "header__hm": _23, "header__left": _24, "header__link": _25, "header__link--collections": _26, "header__link--desktop": _27, "header__link--disabled": _28, "header__link--icon": _29, "header__link-title": _2a, "header__links": _2b, "header__logo": _2c, "header__mobile": _2d, "header__mobile--opened": _2e, "header__mobile-item": _2f, "header__mobile-item-list": _30, "hide-header": _31, "hide-on-small-screens": _32, "iconFancy": _33, "label": _34, "pinned-collection": _35, "pinned-collection__label": _36, "pinned-collection__link": _37, "popover-container": _38, "reset-button": _39, "screenlg": _3a, "screenmd": _3b, "screenml": _3c, "screensm": _3d, "screenxlg": _3e, "screenxs": _3f, "screenxxlg": _40, "screenxxs": _41, "screenxxxlg": _42, "show-header": _43, "show-on-small-screens": _44, "single-page-responsive-font-size": _45 }
